import { ArrowRight } from "lucide-react";
import { ScrollReveal } from "../ui/ScrollReveal";
import { JOIN_URL, IMAGES } from "../../data/content";

export const FinalCTA = () => {
  return (
    <section className="relative bg-[#020617] py-28 sm:py-36 px-5 sm:px-8 overflow-hidden" data-testid="final-cta-section">
      <img
        src={IMAGES.grainTexture}
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-25"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#020617] via-[#020617]/70 to-[#020617]" />
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <ScrollReveal>
          <h2 className="font-display font-extrabold uppercase text-3xl sm:text-5xl lg:text-6xl text-white leading-[1.05]">
            Your Body. Your Mind. <br />
            Your Gut. Your Lifestyle. <br />
            <span className="text-gradient-cyan">One Platform.</span>
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={0.15}>
          <p className="mt-8 font-mono-brand uppercase text-slate-400 tracking-widest text-xs sm:text-sm">
            365 Days · ₹365 · One Healthier You
          </p>
        </ScrollReveal>
        <ScrollReveal delay={0.3}>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <a
              href={JOIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-cyan-400 to-blue-600 px-8 py-4 text-sm font-bold uppercase tracking-wide text-[#020617] shadow-[0_0_35px_rgba(0,240,255,0.4)] hover:shadow-[0_0_50px_rgba(0,240,255,0.6)] hover:scale-[1.03] transition-all duration-300"
              data-testid="final-cta-join"
            >
              Join MindBodyLife.pro Now
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" />
            </a>
            <a
              href="#active360"
              className="inline-flex items-center gap-2 rounded-full border border-slate-600 px-8 py-4 text-sm font-bold uppercase tracking-wide text-slate-200 hover:border-cyan-400 hover:text-cyan-300 transition-colors duration-300"
              data-testid="final-cta-explore"
            >
              Explore Active360™
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
